import BlogCard, { BlogCardProps } from "./BlogCard";

export { BlogCard, BlogCardProps };

export default BlogCard;
